import Icon from '../components/Icon.vue'

Icon.register({
  'user-secret': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M383.9 308.3c38.3 23.7 64.1 65.7 64.1 114.1v44.8c0 24.7-20.1 44.8-44.8 44.8h-358.4c-24.7 0-44.8-20.1-44.8-44.8v-44.8c0-49.7 27.3-92.6 67.4-115.9l-25.8-60.2c-4.5-10.6 3.2-22.3 14.7-22.3h57.5c-11-18.9-17.8-40.6-17.8-64v-0.3c-39.2-7.8-64-19.1-64-31.7 0-13.3 27.3-25.1 70-33 9.2-32.8 27.1-65.8 40.6-82.8 9.5-11.9 25.9-15.6 39.5-8.8l27.6 13.8c9 4.5 19.6 4.5 28.6 0l27.6-13.8c13.6-6.8 30-3.1 39.5 8.8 13.6 17 31.4 50 40.6 82.8 42.8 7.9 70.1 19.7 70.1 33 0 12.6-24.8 23.9-64 31.7v0.3c0 23.4-6.8 45.1-17.8 64h58.5c11.3 0 19 11.2 15 21.7zM176 480l32-120-24-40-49.6-32zM272 480l41.6-192-49.6 32-24 40zM313.7 181.5c0.8-2.6 6.3-5.7 6.4-5.8v-10.8c-28.3 3.7-61 5.8-96 5.8s-67.7-2.2-96-5.8v10.8c0 0.1 5.5 3.3 6.3 5.8 3.8 11.9 7 24.6 16.5 33.4 8 7.4 47 25.2 64-25 2.9-8.4 15.5-8.4 18.3 0 16 47.4 53.9 34.3 64 25 9.5-8.8 12.6-21.5 16.5-33.4z'
      }
    ]
  }
})
